
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import { useToast } from "vue-toastification";
const toast = useToast();
export default function messages() {

    const notification = (type:string, messages: any) => {
        switch ( type ) {
            case 'success':
                    toast.success(messages);        
                break;
            case 'info':
                    toast.info(messages);
                break;
            case 'warning':
                toast.warning(messages);
                break;
            case 'error':
                toast.error(messages);
                break;
            default: 
            toast(messages);
                break;
        }
    }
    function detailNotification(icons: any, title: any, dto: any, startparameter: number) {
        let i = 0;
        let valueDto = '<ul align="left">';
        for (const propName in dto) {
            i++;
            if (i > startparameter) {
                valueDto += '<li>' + propName.toUpperCase() + ': <b>' + dto[propName] + '</b></li>';
            }
        }
        valueDto += '</ul>';

        Swal.fire({ title: title, html: valueDto, icon: icons })
    }

    function sendParameters(icons: any, title: any, dto: any, startparameter: number, show: string) {
        let i = 0;
        let valueDto = '<ul align="left">';
        for (const propName in dto) {
            if (startparameter == 1) {
                if (show.includes(i.toString())) { valueDto += '<li>' + propName.toUpperCase() + ': <b>' + dto[propName] + '</b></li>'; }
            } else {
                valueDto += '<li>' + propName.toUpperCase() + ': <b>' + dto[propName] + '</b></li>';
            }
            i++;
        }
        valueDto += '</ul>';

        return Swal.fire({
            title: title,
            html: valueDto,
            icon: icons,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Accept",
            focusCancel: true,
            preConfirm: (isConfirm) => {
                return isConfirm;
            }
        }).then(response => {
            Swal.close();
            return response.value;
        });

    }

    function sendThreeButtons(icons: any, title: any, dto: any, startparameter: number, show: string, buttonThree: string) {
        let i = 0;
        let valueDto = '<ul align="left">';
        for (const propName in dto) {
            if (startparameter == 1) {
                if (show.includes(i.toString())) { valueDto += '<li>' + propName.toUpperCase() + ': <b>' + dto[propName] + '</b></li>'; }
            } else {
                valueDto += '<li>' + propName.toUpperCase() + ': <b>' + dto[propName] + '</b></li>';
            }
            i++;
        }
        valueDto += '</ul>';

        return Swal.fire({
            title: title,
            html: valueDto,
            icon: icons,
            confirmButtonColor: "#1f7e49",
            confirmButtonText: buttonThree,
            denyButtonColor: "#3085d6",
            showDenyButton: true,
            denyButtonText: 'Accept',
            focusCancel: true,
            showCancelButton: true,
            cancelButtonColor: "#b82222",
            preConfirm: (isConfirm) => {
                return isConfirm;
            },
        }).then(response => {
            Swal.close();
            return response;
        });

    }

    const validateNotification = (dto: any) => {
        if (!dto.validate) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                },
                icon: 'info',
                html: dto.required,
                showCancelButton: false
            });
        }
    };

    const alertAutorizationModule = (module: string, message: string) => {
        Swal.fire({
            icon: "error",
            title: "Module " + module,
            text: message,
            footer: '<a href="#">consult with goconnexus support</a>'
        });
    }

    const alertAutorizationAction = (acction: string, message: string) => {
        Swal.fire({
            icon: "error",
            title: "Action " + acction,
            text: message,
            footer: '<a href="#">consult with goconnexus support</a>'
        });
    }

    const alertAutorization = (title: string, message: string) => {
        Swal.fire({
            icon: "error",
            title: message,
            //text: title,         
            footer: '<a href="#">consult with goconnexus support</a>'
        });
    }

    const loading = (message: string | null) => {
        Swal.fire({
            title: message ?? 'Processing Please Wait...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading(null);
            }
        });
    }

    const closeLoading = () => {
        Swal.close();
    }


    const logOut = (msj: string, total: number) => {
        let messages = '';
        if (total > 0) {
            messages = `<div class="logout-swal-content"><div class="logout-swal-icon"></div><div>${total}, ${msj} Wish To Continue</div></div>`;
        } else {
            messages = `<div class="logout-swal-content"><div class="logout-swal-icon"></div><div> Esta seguro de cerrar sesión</div></div>`;
        }

        return Swal.fire({
            title: '<span class="logout-swal-title">Cerrar Sessión</span>',
            html: messages,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Acceptar",
            cancelButtonText: "Cancelar",
            focusCancel: true,
            backdrop: 'rgba(10,43,60,0.5)',
            customClass: {
                confirmButton: 'logout-confirm-button',
                cancelButton: 'logout-cancel-button'
            },
            preConfirm: (isConfirm) => {
                return isConfirm;
            }
        }).then(response => {
            Swal.close();
            return response.value;
        });

    }

    return { notification, detailNotification, sendParameters, validateNotification, alertAutorizationModule, alertAutorizationAction, alertAutorization, loading, closeLoading, sendThreeButtons, logOut }
}